// Titles/labels in this form use a non-breaking space to control line wraps for display, but
// Step Started and Step Completed must send the same plain-space step_label so Segment can join
// the two events on it.
function normalizeStepLabel(title: string): string {
  return title.replaceAll(' ', ' ');
}

export { normalizeStepLabel };
